import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {Layout} from 'TemplateEditor/Layout'
import EditorProvider from 'TemplateEditor/EditorProvider'
import TemplateProvider from 'TemplateEditor/TemplateProvider'
import {EventModel} from 'event/models/Event'
import FunctionsProvider from 'TemplateEditor/FunctionsProvider'
import {attendeeApiClient} from 'attendee/apiClient'
import {toast} from 'react-toastify'
import {useEventPreview} from 'event/providers/EventPreviewProvider'
import Modals from 'attendee/theme/Modals'
import EventProvider from 'event/providers/EventProvider'
import {routes} from 'routes/routes'

export function PreviewTemplate(props: {event?: EventModel}) {
  const {event} = props
  const viewerTicketId = event?.viewer_event_ticket_id

  return (
    <>
      <Modals />
      <FunctionsProvider joinMeeting={useJoinMeeting()}>
        <EventProvider>
          <TemplateProvider event={event}>
            <EditorProvider
              editMode={false}
              viewerEventTicketId={viewerTicketId}
            >
              <Layout />
            </EditorProvider>
          </TemplateProvider>
        </EventProvider>
      </FunctionsProvider>
    </>
  )
}

function useJoinMeeting() {
  const {t} = useI18n()
  const apiClient = attendeeApiClient()
  const {event} = useEventPreview()

  const join = async () => {
    const newTab = window.open(routes.loadingPage, '_blank')

    try {
      const response = await apiClient.get<{join_link: string}>(
        `api/event/${event?.id}/join-link`,
      )

      const url = response.join_link

      if (!url) {
        toast.warning(t('org.attendees.noJoinLink'))
        if (newTab) newTab.close()
        return
      }

      if (newTab) {
        newTab.location.href = url
      }
    } catch (error: any) {
      toast.warning(
        error.response?.data?.message || t('org.attendees.somethingWrong'),
      )
      if (newTab) newTab.close()
    }
  }

  return {
    join,
  }
}
